import React from 'react';

import { Button, Surface } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import classes from './CoachStatusToggle.module.scss';
import { openConfirmationModal } from '../../../../shared/features/confirmation';
import { useCoachSeatsValidation } from '../../../../payment';
import { PaymentFlowTypeFlags } from '../../../../shared/constants/user-info/paymentFlowType';

type CoachStatusToggleProps = {
  active: boolean;
  coachName: string;
  onActivationChange: () => void;
  entityId: number;
  paymentFlowType: PaymentFlowTypeFlags;
};

export const CoachStatusToggle = observer(
  ({
    active,
    coachName,
    onActivationChange,
    entityId,
    paymentFlowType,
  }: CoachStatusToggleProps) => {
    const { handleAddCoachValidation } = useCoachSeatsValidation(entityId);

    const handleDeactivateAccount = () => {
      openConfirmationModal({
        title: (
          <>
            Are you sure you want to deactivate the account &quot;
            <span className="private-info">{coachName}</span>&quot;?
          </>
        ),
        text: 'Make sure all customers of this coach are reassigned to another coach',
        confirmBtnConfig: {
          text: 'Confirm',
          onClick: () => onActivationChange(),
        },
      });
    };

    const handleActivateAccount = () => {
      if (!paymentFlowType.NEW_USER_FLOW_2024) {
        confirmActivateAccount();
      } else {
        handleAddCoachValidation(confirmActivateAccount);
      }
    };

    const confirmActivateAccount = () =>
      openConfirmationModal({
        title: (
          <>
            Are you sure you want to activate the account &quot;
            <span className="private-info">{coachName}</span>&quot;?
          </>
        ),
        confirmBtnConfig: {
          text: 'Confirm',
          onClick: () => onActivationChange(),
        },
      });

    return (
      <Surface className={classes.box}>
        {active ? (
          <Button variant="text" color="primary" onClick={handleDeactivateAccount}>
            Deactivate Account
          </Button>
        ) : (
          <Button variant="text" color="primary" onClick={handleActivateAccount}>
            Activate Account
          </Button>
        )}
      </Surface>
    );
  },
);
